import {lazy} from '@aboutyou/lazy-imports';
import {BasketPageSkeletonDesktop} from '@aboutyou/logic-components';
import React from 'react';

const NewBasketEager = lazy(
  () =>
    import('./BasketPage.eager').then(mod => ({default: mod.BasketPageEager})),
  {
    fallback: <BasketPageSkeletonDesktop />,
    aboveTheFold: true,
  },
);

export const BasketPage = () => {
  return <NewBasketEager />;
};
